import { render, staticRenderFns } from "./HortensioTwo.vue?vue&type=template&id=7f45c2b8&scoped=true&"
import script from "./HortensioTwo.vue?vue&type=script&lang=js&"
export * from "./HortensioTwo.vue?vue&type=script&lang=js&"
import style0 from "./HortensioTwo.vue?vue&type=style&index=0&id=7f45c2b8&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fhortensiatwo&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45c2b8",
  null
  
)

export default component.exports